/* @ngInject */
const compositionOptions = (
  utils,
  types,
  excelStyles,
  wagonUtils,
) => {
  const self = {}

  self.generateOptions = (_options) => {
    const options = utils.copy(_options)
    options.filename = 'compositionTrain'
    options.enableColor = true
    options.enableOwnerSheet = false
    options.firstRow = 7
    options.getBodyCells = self.getBodyCells
    options.getBodyCells2 = self.getBodyCells2
    options.style = excelStyles.bodyCell()
    options.style2 = excelStyles.underline
    options.secondSheet = 0
    return options
  }


  self.getBodyCells2 = ({ firstRow, }, wagons) => {
    return [{
      name: `E${wagons.length + firstRow}`,
      value: 'TOTAL :',
    }, {
      name: `F${wagons.length + firstRow}`,
      value: `=SUM(F${firstRow}:F${firstRow + wagons.length - 1})`,
      type: types.decimal,
    }, {
      name: `G${wagons.length + firstRow}`,
      value: `m`,
    },]
  }

  self.getBodyCells = ({ currentRow, firstRow, }, wagon,) => {
    return [{
      name: 'A' + currentRow,
      value: currentRow - firstRow + 1,
      type: types.integer,
    }, {
      ref: 'id',
      name: 'B' + currentRow,
      value: wagon.id,
      type: types.wagonId,
    }, {
      ref: 'owner',
      name: 'C' + currentRow,
      value: wagon.owner,
    }, {
      ref: 'type',
      name: 'D' + currentRow,
      value: wagon.type,
    }, {
      name: 'E' + currentRow,
      value: wagon.completeRevisionExcel,
      ref: 'completeRevisionExcel',
    }, {
      name: 'F' + currentRow,
      value: wagon.length,
      type: types.decimal,
    }, {
      ref: 'tare',
      name: 'G' + currentRow,
      value: wagon.tare,
      type: types.integer,
    }, {
      ref: 'brakedMass',
      name: 'H' + currentRow,
      value: wagon.brakedMass,
      type: types.integer,
    }, {
      name: 'I' + currentRow,
      value: wagon.isolated,
      ref: 'isolated',
    }, {
      ref: 'elv',
      name: 'J' + currentRow,
      value: wagon.elv,
    }, {
      ref: 'idNew',
      name: 'K' + currentRow,
      value: wagon.idNew ? `Nouveau numéro : \n${wagonUtils.idToString(wagon.idNew)}` : ''
    },]
  }

  return self
}
export default compositionOptions



// WEBPACK FOOTER //
// ./public/javascript/sygem/global/services/excel/wagon/compositionOptions.resource.js